import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import cloneDeep from 'lodash/cloneDeep';
import { CheckboxRow, InputGroup, Label, LabelCheckbox, Divider as DefaultDivider } from 'prospect-path-components';

const Divider = styled(DefaultDivider)`
  margin: 1rem 0;
`;

const Container = styled.div`
  margin-bottom: 2rem;
`;

export default class DataGroupChecklist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: [],
    };

    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.toggleSelectNone = this.toggleSelectNone.bind(this);
  }
  componentWillMount() {
    const { defaultValues } = this.props;

    this.setState({ checked: defaultValues });
  }
  toggleSelectAll() {
    if (this.props.disabled) {
      return;
    }

    const checked = [...this.props.options];

    this.setState({ checked }, () => this.props.onChange(this.props.id, this.state.checked));
  }
  toggleSelectNone() {
    if (this.props.disabled) {
      return;
    }

    const checked = [];

    this.setState({ checked }, () => this.props.onChange(this.props.id, this.state.checked));
  }
  handleCheckboxChange(option) {
    if (this.props.disabled) {
      return;
    }

    if (this.state.checked.find(checked => checked.id === option.id) === undefined) {
      this.addChecked(option);

      return;
    }

    this.removeChecked(option);
  }
  addChecked(option) {
    const checked = cloneDeep(this.state.checked);

    checked.push(option);

    this.setState({ checked }, () => this.props.onChange(this.props.id, this.state.checked));
  }
  removeChecked(option) {
    const checked = cloneDeep(this.state.checked).filter(checkedOption => checkedOption.id !== option.id);

    this.setState({ checked }, () => this.props.onChange(this.props.id, this.state.checked));
  }
  render() {
    return (
      <Container>
        <InputGroup>
          {this.props.label && <Label>{this.props.label}</Label>}

          {this.props.showSelectAllNone && (
            <CheckboxRow>
              <LabelCheckbox disabled={this.props.disabled} label="Select all" onChange={this.toggleSelectAll} checked={this.state.checked.length === this.props.options.length} />
              <LabelCheckbox disabled={this.props.disabled} label="Select none" onChange={this.toggleSelectNone} />
            </CheckboxRow>
          )}

          {this.props.showSelectAllNone && <Divider />}

          {chunk(this.props.options, 3).map((options, index) => (
            <CheckboxRow key={index}>
              {options.map(option => (
                <LabelCheckbox
                  key={option.id}
                  label={option.name}
                  onChange={() => this.handleCheckboxChange(option)}
                  checked={this.state.checked.find(checked => checked.id === option.id) !== undefined}
                  disabled={this.props.disabled}
                />
            ))}
            </CheckboxRow>
        ))}
        </InputGroup>
      </Container>
    );
  }
}

DataGroupChecklist.propTypes = {
  id: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showSelectAllNone: PropTypes.bool,
  defaultValues: PropTypes.array,
  disabled: PropTypes.bool,
};

DataGroupChecklist.defaultProps = {
  label: null,
  showSelectAllNone: false,
  defaultValues: [],
  disabled: false,
};
